module.exports = __webpack_public_path__ + "media/images/icon_about5-02440987573bcc957f38d288a417a623.png";